
  document.addEventListener("DOMContentLoaded", () => {
    const atcBar = document.querySelector(".sticky-atc-bar");
    const footer = document.querySelector(".footer");

    if (!atcBar || !footer) return;

    // Hide the ATC bar when the footer enters the viewport, show it otherwise
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        atcBar.style.display = entry.isIntersecting ? "none" : "";
      },
      {
        root: null,        // viewport
        threshold: 0,      // trigger as soon as footer touches viewport
      }
    );

    observer.observe(footer);


    // Read more product description
      document.addEventListener("click", function(e) {
        if (!e.target.closest("[data-read-more-toggle]")) return;

        const button = e.target.closest("[data-read-more-toggle]");
        const wrapper = button.closest(".product__block");
        const description = wrapper.querySelector(".pdp-read-more-description");
        const text = button.querySelector(".pdp-read-more-text");

        description.classList.toggle("is-open");
        button.classList.toggle("is-open");

        if (description.classList.contains("is-open")) {
          text.textContent = "Read Less";
        } else {
          text.textContent = "Read More";
        }
      });
  });

